import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserStore } from '../services/user-store.service';

/** Quien tiene el rol contador entra, aunque también sea admin o líder. */
export const contadorGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  if (!userStore.isLoggedIn()) {
    return router.createUrlTree(['/login']);
  }

  if (userStore.isContador()) {
    return true;
  }

  if (userStore.isAdmin()) {
    return router.createUrlTree(['/congregacion']);
  }

  if (userStore.isLider()) {
    return router.createUrlTree(['/lider']);
  }

  return router.createUrlTree(['/login']);
};
